module.exports = __webpack_public_path__ + "img/bgYellowQR.0d40b14d.svg";